export default __webpack_public_path__ + "static/card-4-31b121cb965166cc8ce934ec1a1f9649.png";